import { useLocation } from 'quartz-routing/react-router';
import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
export function useRouteOfferingType() {
  const {
    pathname
  } = useLocation();
  return pathname.includes('/website') ? OfferingType.THEME : pathname.includes('/modules') ? OfferingType.MODULE : OfferingType.THEME;
}